const $body = document.querySelector("body");
let scrollPosition = 0;
const disableScrollBody = {
	enable: () => {
		scrollPosition = window.pageYOffset;
		$body.style.overflow = "hidden";
		$body.style.position = "fixed";
		$body.style.top = `-${scrollPosition}px`;
		$body.style.width = "100%";
	},
	disable: () => {
		$body.style.removeProperty("overflow");
		$body.style.removeProperty("position");
		$body.style.removeProperty("top");
		$body.style.removeProperty("width");
		window.scrollTo(0, scrollPosition);
	},
};
export function headerSearch() {
	function closeSearch() {
		if ($(".header-search-form").hasClass("active")) {
			$(".header-search-form").removeClass("active");
			$(".backdrop-overlay").removeClass("active");
			$("body").removeClass("disable");
			disableScrollBody.disable();
		}
	}
	$(".header-search").on("click", function () {
		$(".header-search-form").addClass("active");
		$(".backdrop-overlay").addClass("active");
		$("body").addClass("disable");
		disableScrollBody.enable();
		setTimeout(() => {
			$(".header-search-form input").focus();
		}, 400);
	});
	$(".header-search-form .close").on("click", function () {
		closeSearch();
	});
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			closeSearch();
		}
	});
	$(document).on("click", function (e) {
		if ($(".header-search-form").hasClass("active")) {
			if (!$(e.target).closest(".header-search-form").length && !$(e.target).closest(".header-search").length) {
				closeSearch();
			}
		}
	});
}
